export const createSearchState = () => ({
    isLoading: false,
    search: null,
    timer: null,
    lastQuery: null,
    debounceTimer: 300,
})
